import React from 'react';
import ImageWithFallback from './ImageWithFallback';
import './App.css';

const RainbowTurtle = () => {
  return (
    <div className="page-container">
      <div className="hero-section">
        <h1>Rainbow Turtle</h1>
        <p>Create a beautiful rainbow turtle with this colorful coding project.</p>
        <div
          style={{
            width: "100%",
            maxWidth: "400px",
            height: "300px",
            borderRadius: "18px",
            marginBottom: "18px",
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 24px auto",
          }}
        >
          <ImageWithFallback 
            src="/rainbow_turtle.gif" 
            alt="Rainbow Turtle" 
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              borderRadius: "18px",
            }}
          />
        </div>
      </div>
      <div className="content-section">
        <h2>Project Description</h2>
        <p>This project draws a colorful rainbow turtle using Python code and turtle graphics.</p>
        <h2>Download</h2>
        <a href="/rainbow_turtle.py" download>Download rainbow_turtle.py</a>
        <h2>How to Run</h2>
        <p>Run the Python file in your local environment to see the rainbow turtle being drawn.</p>
      </div>
    </div>
  );
};

export default RainbowTurtle;
